import { defineStore } from 'pinia';
import { ref } from 'vue';

// Command-palette (Cmd/Ctrl-K) open state. Tiny by design: the palette's
// command set + dynamic search live in CommandPalette.vue (the host), and the
// global key handler in AppShell + the nav search box just flip `open` here.
// A store (not local AppShell state) so any surface can open the palette.
export const usePaletteStore = defineStore('palette', () => {
  const open = ref(false);
  function openPanel(): void { open.value = true; }
  function closePanel(): void { open.value = false; }
  function toggle(): void { open.value = !open.value; }
  return { open, openPanel, closePanel, toggle };
});
